import { defineNuxtPlugin } from "#app";
import { useArtworkViewTransition } from "~/composables/useArtworkViewTransition";
import { useArtistViewTransition } from "~/composables/useArtistViewTransition";

export default defineNuxtPlugin((nuxtApp) => {
  const { onTransitionStart: onArtworkTransitionStart } = useArtworkViewTransition();
  const { onTransitionStart: onArtistTransitionStart } = useArtistViewTransition();

  nuxtApp.hook("page:start", () => {
    if (import.meta.dev) {
      console.log(`[View Transition] page:start (t=${Math.round(performance.now())}ms)`);
    }
  });

  nuxtApp.hook("page:view-transition:start", (transition: any) => {
    onArtworkTransitionStart(transition);
    onArtistTransitionStart(transition);
  });

  nuxtApp.hook("page:finish", () => {
    if (import.meta.dev) {
      console.log(`[View Transition] page:finish (t=${Math.round(performance.now())}ms)`);
    }
  });
});

